import { render, staticRenderFns } from "./SpoilerForm.vue?vue&type=template&id=4975bd5d&scoped=true&"
import script from "./SpoilerForm.vue?vue&type=script&lang=js&"
export * from "./SpoilerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975bd5d",
  null
  
)

export default component.exports